// Player feedback, client side (spec 2026-10-24). `send_feedback` does the
// real work and the real checks: it trims, bounds, rate-limits and redacts
// the message, emails it to every admin, and never stores it.
import type { SupabaseClient } from '@supabase/supabase-js';

/** The longest message `send_feedback` accepts. */
export const FEEDBACK_MAX = 500;

export type FeedbackOutcome =
  | { kind: 'sent' }
  /** One was sent in the last ten minutes; try again in `seconds`. */
  | { kind: 'wait'; seconds: number }
  /** The server cannot email right now (no mail settings, or no admin). */
  | { kind: 'unavailable' }
  | { kind: 'error' };

export async function sendFeedback(c: SupabaseClient, message: string): Promise<FeedbackOutcome> {
  const { data, error } = await c.rpc('send_feedback', { message });
  if (error) return { kind: 'error' };
  const r = (data ?? {}) as { delivered?: unknown; retry_in?: unknown };
  if (r.delivered === 'sent') return { kind: 'sent' };
  if (r.delivered === 'wait') {
    return { kind: 'wait', seconds: typeof r.retry_in === 'number' ? r.retry_in : 600 };
  }
  if (r.delivered === 'unconfigured' || r.delivered === 'no_admins') return { kind: 'unavailable' };
  return { kind: 'error' };
}
